<!--  -->
<template>
  <div class="logo-container">
    <div class="logo-body">
      <img src="~@/assets/images/logo.png" class="logo" />
      <span class="logo-text" v-if="showTitle">{{title}}</span>
    </div>
    <div class="logo-game">
      <a-select
        v-model:value="autoData.autoValue"
        style="width: 100%"
        placeholder="请选择游戏"
        show-search
        :default-active-first-option="true"
        :show-arrow="false"
        :filter-option="false"
        :not-found-content="autoData.fetching ? undefined : null"
        @search="fetchUser"
        @change="selectChange"
        @focus="focusChange"
      >
        <template v-if="autoData.fetching" #notFoundContent>
          <a-spin size="small" />
        </template>
        <a-select-option v-for="d in autoData.data" :key="d" :value="d.code">{{ d.name }}</a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import { useStore } from "vuex";
export default {
  props: {
    showTitle: Boolean,
    autoData: Object
  },
  setup(props, { attr, slots, emit }) {
    const store = useStore();
    const title = store.state.settings.title;
    // 事件
    const fetchUser = value => {
      emit("fetchUser", value);
    };
    const selectChange = value => {
      emit("selectChange", value);
    };
    const focusChange = () => {
      emit("focusChange");
    };
    return {
      title,
      fetchUser,
      selectChange,
      focusChange
    };
  }
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.logo-container {
  .logo-body {
    #flex-box.row-c-c();
    padding: 10px;
    .logo {
      height: 36px;
      width: 36px;
    }
    .logo-text {
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      padding-left: 10px;
    }
  }
}
</style>